import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent
} from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

@Injectable()
export class AzureAuthorizationInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const clonedRequest = request.clone({ setHeaders: { 'Ocp-Apim-Subscription-Key': '03131d3df4b04e4ca9c23c1cea2a2abb' } });
        return next.handle(clonedRequest);
    }
}


// WEBPACK FOOTER //
// ./src/app/interceptor.service.ts